import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    // 即时订单
    immediateData: {
      checkList: [], // 服务时段列表
      goodsTypeId: "", //一级商品类目id
      takeDeliveryFee: "", //是否含送货费
      isJishiTihuoFei:false, // 是否含有提货费
      serviceType: "", //服务类型id
      customerName: "", //客户姓名
      customerPhone: "", //客户电话
      isLift: "", //是否有电梯
      floorsNumber: "", //楼层数
      areaCode: [], //地区code
      address: "", //联系地址
      pickupAreaCode:[],//提货地址code
      pickupAddress:'',//提货地址
      addressText:'',
      orderItems: [
        //商品列表
        {
          fileList: [], //图片list
          videoList: [], //视频list
          imgUrl: "", //图片地址
          installVideoUrl: "", //视频地址
          goodsTypeIdList: [], //商品类别id数组
          goodsTypeId: "", //商品类别id
          name: "", //商品名称
          count: "1", //商品数量
          packingMethod: "", //包装方式
          description: "", // 商品描述
        },
      ],
      totalVolume: '1', // 订单总体积
      packingCount: "1", //包装数量
      isArrival: "true", //是否到货
      logisticsNo: "", //物流单号
      logisticsPhone: "", //物流电话
      logisticsCompany: "", //物流公司
      pickupCode: "", //提货码
      pickupAddress: "", //提货地址
      verifType: "NOT", //是否核销
      verifOrderNo: "", //核销订单号
      expectedTime: "", //期望服务时间
      remark: "", //备注
      userName: "", //您的姓名
      userPhone: "", //您的电话
      transportTime:'' //运输时间
    },
    orderData: {
      goodsTypeId: "", //一级商品类目id
      takeDeliveryFee: "", //是否含送货费
      serviceType: "", //服务类型id
      customerName: "", //客户姓名
      customerPhone: "", //客户电话
      isLift: "", //是否有电梯
      floorsNumber: "", //楼层数
      areaCode: [], //地区code
      address: "", //联系地址
      orderItems: [
        //商品列表
        {
          fileList: [], //图片list
          videoList: [], //视频list
          imgUrl: "", //图片地址
          installVideoUrl: "", //视频地址
          goodsTypeIdList: [], //商品类别id数组
          goodsTypeId: "", //商品类别id
          name: "", //商品名称
          count: "1", //商品数量
          packingMethod: "", //包装方式
          description: "", // 商品描述
        },
      ],
      totalVolume: "1", // 订单总体积
      packingCount: "1", //包装数量
      isArrival: "true", //是否到货
      logisticsNo: "", //物流单号
      logisticsPhone: "", //物流电话
      logisticsCompany: "", //物流公司
      pickupCode: "", //提货码
      pickupAddress: "", //提货地址
      verifType: "NOT", //是否核销
      verifOrderNo: "", //核销订单号
      expectedTime: "", //期望服务时间
      remark: "", //备注
      userName: "", //您的姓名
      userPhone: "", //您的电话
    },

    hasPwd: false, //判断是否有设置密码
    userPhone: "", //用户手机号
    userName: "", //用户名
    userAvatar: "", //用户头像
    userInfo: {}, //用户信息
    priceList: {
      orderServiceFees: [],
    },
    // 即时下单金额
    immediatePrice:{
      orderServiceFees:[]
    },
    headerTabList: [
      { name: "关于我们", isSelected: false },
      { name: "维权中心", isSelected: false },
      { name: "我的钱包", isSelected: false },
      { name: "我的订单", isSelected: false },
      { name: "首页", isSelected: false },
    ],
    userList: [
      { name: "全部订单", isSelected: true },
      { name: "退款订单", isSelected: false },
      { name: "我的钱包", isSelected: false },
      { name: "我的账单", isSelected: false },
      { name: "我的商品", isSelected: false },
      { name: "异常跟进", isSelected: false },
      // { name: "订单盈亏", isSelected: false },
      { name: "批量下单", isSelected: false },
      { name: "消息通知", isSelected: false },
      { name: "平台公告", isSelected: false },
      { name: "维权中心", isSelected: false },
      { name: "帮助中心", isSelected: false },
      { name: "意见反馈", isSelected: false },
      { name: "安全设置", isSelected: false },
      { name: "个人设置", isSelected: false },
      { name: "关于我们", isSelected: false },
    ],
    aboutList: [
      { name: "关于聚师傅", isSelected: true },
      { name: "联系我们", isSelected: false },
      // {name:"企业文化",isSelected:false},
      // {name:"商务合作",isSelected:false},
      // {name:"人才招聘",isSelected:false},
    ],
    login: false,
    badge: true,
    abnormal: true,
    defaultUrl: "",
    announcement: true,
  },
  mutations: {},
  actions: {},
});
